import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-buyer-details-event-data',
  templateUrl: './buyer-details-event-data.component.html',
  styleUrls: ['./buyer-details-event-data.component.scss'],
})
export class BuyerDetailsEventDataComponent {
  @Input() buyer_id?: string | null;
  is_read_running = true;

  ngOnInit(): void {
    this.listBuyerEvent(this.buyer_id as string);
  }

  onRefresh(): void {
    this.listBuyerEvent(this.buyer_id as string);
  }

  listBuyerEvent(seller_id?: string): void {
    this.is_read_running = true;

    if (seller_id) {
      this.is_read_running = false;
    }
  }
}
